import hatchLogo from "#app/assets/images/integrations/hatch.svg";
import rooflinkLogo from "#app/assets/images/integrations/rooflink.svg";
import acculynxLogo from "#app/assets/images/integrations/acculynx.svg";
import servicetitanLogo from "#app/assets/images/integrations/servicetitan.svg";
import slackLogo from "#app/assets/images/integrations/slack.svg";

// Full-color brand logo tiles, keyed by provider slug. A provider with an entry
// renders its logo on the Integration Hub cards; the rest fall back to their
// registry `icon` (for example, Webhook).
// The asset + association are client concerns, so there's no server field — the
// server only sends the provider slug.
//
// Use the OFFICIAL mark from the vendor's brand kit, never an approximation —
// a redrawn logo breaks most brand guidelines and looks wrong beside the real
// ones. Adding the import and the slug entry is the whole job: the logo then
// appears on the hub card AND in the automation Action node's Source dropdown,
// which calls `brandLogo`.
//
// Two shapes are in play, and they do not look alike. The first four are TILES
// — 256x256, a solid brand-color background, `rx=40` rounding baked in to match
// the chip's `rounded="md"` — so they fill the chip edge to edge. `slack.svg` is
// the BARE mark on a transparent background, so it floats on whatever surface is
// behind it. Both render; the bare mark just reads smaller and un-tiled beside
// the others. Wrap a bare mark the same way if that inconsistency matters.
export const BRAND_LOGOS: Record<string, string> = {
  hatch: hatchLogo,
  rooflink: rooflinkLogo,
  acculynx: acculynxLogo,
  servicetitan: servicetitanLogo,
  slack: slackLogo,
};

/** The brand logo URI for a provider slug, or undefined to fall back to `icon`. */
export function brandLogo(slug: string): string | undefined {
  return BRAND_LOGOS[slug];
}
